<template>
    <div>
        <LoaderSplash :loaded="loaded">
            <b-container v-if="loaded">
                <b-row>
                    <b-col>

                        <div class="event-header">
                            <div class="row">
                                <div
                                        class="col-sm-9 event-header__main-image"
                                        v-bind:style="{ backgroundImage: 'url(' + event.image + ')'}">

                                </div>
                                <div
                                        class="col-sm-3 event-header__info"
                                        v-bind:style="{backgroundColor: event.client.header_color}"
                                >
                                    <img :src="event.client.logo" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="event-details-wrap">
                            <div class="event-book-bar">
                                <div class="row">
                                    <div class="col-sm-9 p-3 d-none d-md-flex event-book-bar__intro">
                                        <p class="h4">Hi {{ invite.first_name}}, You have been invited to {{ event.name }}</p>
                                    </div>
                                    <div class="col-sm-3 p-3 event-book-bar__right">
                                        <a href="#book-now" class="btn btn-success event-book-bar__btn">Reserve your spot</a>
                                    </div>
                                </div>
                            </div>
                            <div class="event__description">

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div v-html="event.description" class=""></div>
<!--                                        <hr>-->
<!--                                        <TimesBlock :event="event" class="mt-auto"/>-->
                                    </div>
                                    <div class="col-sm-6">
                                        <p class="h4 mt-3">
                                            Itinerary
                                        </p>

                                        <div v-for="(day, i) in event.days" :key="i">
                                            <p><b>{{ getDayString(day) }}</b></p>

                                            <div class="itinerary__inner" v-for="(itinerary_item, j) in day.itinerary_items" :key="j">
                                                <itinerary-item :item="itinerary_item"></itinerary-item>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <LocationBlock :event="event"/>

                                    </div>
                                    <div class="col-sm-6 updates-col">
                                        <p class="h4 mt-3">
                                            Updates
                                        </p>

                                        <div v-for="(update, index) in event.updates" :key="index">
                                            <update :update="update"></update>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </b-col>
                </b-row>

                <b-row class="mt-3" id="book-now">
                    <b-col>

                        <div class="confirm-block">
                            <div v-if="!show_booking_form">
                                <div v-if="status == 'ACCEPTED'" class="confirm-block__accepted">
                                    <p class="confirm-block__title">
                                        {{ AcceptedText }}
                                    </p>

<!--                                    <p class="confirm-block__subtitle">-->
<!--                                        If you change your mind, -->
<!--                                        <a href="#" @click.prevent="setStatus('DEFAULT')">click here</a>                                    -->
<!--                                    </p>-->
                                </div>

                                <div v-if="status == 'REJECTED'" class="confirm-block__rejected">
                                    <p class="confirm-block__title">
                                        {{ RejectedText }}
                                    </p>

                                    <p class="confirm-block__subtitle">
                                        If you change your mind, 
                                        <a href="#" @click.prevent="setStatus('DEFAULT')">click here</a>                                    
                                    </p>
                                </div>

                                <div v-if="status == 'DEFAULT'" class="confirm-block__default">
                                    <p class="confirm-block__title">
                                        {{ CTAText }}
                                    </p>

                                    <div class="confirm-block__buttons">
                                        <a href="" @click.prevent="showBookingForm()" class="confirm-block__yes">Yes, reserve my spot</a>
                                        <a href="" @click.prevent="setStatus('REJECTED')" class="confirm-block__no">No, I cant make it</a>
                                    </div>
                                </div>
                            </div>

                            <div v-if="show_booking_form">
                                <div class="confirm-block__booking">
                                    <p class="confirm-block__title">
                                        {{ BookingText }}
                                    </p>

                                    <p class="confirm-block__subtitle">
                                        Or
                                        <a href="#" @click.prevent="hideBookingForm()">book another time</a>                                    
                                    </p>
                                </div>
                            </div>                            
                        </div>

                        <transition name="slide-fade">
                            <div v-if="show_booking_form" class="confirm-block__form">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <p class="confirm-block__form-heading">
                                            Please answer the following questions.
                                        </p>

                                        <answerable-question-list 
                                            :questions="invite.event.questions" 
                                            :answers="invite.answers"
                                            @changed="answersChanged">

                                        </answerable-question-list>
                                    </div>
                                    <div class="col-sm-12">
                                        <div v-if="event.cost > 0">
                                            <p class="confirm-block__form-heading">
                                                There is a fee of £{{ event.cost }} to attend this event.
                                            </p>

                                            <div v-if="event.requires_payment_upfront">
                                                <p class="confirm-block__form-heading">
                                                    Please provide payment details.
                                                </p>

                                                <div class="card-payment">
                                                    <p class="clear-fix"><i class="fas fa-lock"></i> Secure card payment
                                                        <img class="stripe-logo" src="@/assets/powered_by_stripe.svg">
                                                    </p>

                                                    <card class='stripe-card'
                                                          :class='{ complete }'
                                                          :stripe='stripe_public_key'
                                                          :options='stripeOptions'
                                                          @change='payment_details_complete = $event.complete'
                                                    />
                                                    <button class="btn btn-success confirm-block__confirm-button" :disabled='!payment_details_complete' @click="confirmPaid">
                                                        Confirm your booking
                                                    </button>

                                                </div>
                                            </div>


                                        </div>

                                        <button v-if="!event.requires_payment_upfront" class="btn btn-success confirm-block__confirm-button" @click="confirmUnpaid">
                                            Confirm your booking
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </b-col>
                </b-row>
            </b-container>

        </LoaderSplash>

    </div>
</template>

<script>
    import moment from 'moment';
    import ItineraryItem from '@/components/ItineraryItem.vue';
    import Update from '@/components/Update.vue';
    import AnswerableQuestionList from '@/components/AnswerableQuestionList.vue';

    import inviteRepository from "@/repository/invites";
    import LocationBlock from "@/components/LocationBlock";
    import TimesBlock from "@/components/TimesBlock";

    import { Card, createToken } from 'vue-stripe-elements-plus';

    const stripe_public_key = process.env.VUE_APP_STRIPE_KEY;
    export default {
        components: {
            ItineraryItem,
            Update,
            AnswerableQuestionList,
            LocationBlock,
            TimesBlock,
            Card
        },

        props: ['id'],

        data(){
            return {

                //stripe stuff - move
                payment_details_complete: false,
                stripeOptions: {
                    // see https://stripe.com/docs/stripe.js#element-options for details
                },
                stripe_public_key,

                status: 'DEFAULT', // [DEFAULT, ACCEPTED, REJECTED]
                show_booking_form: false,

                loaded:false,
                invite:null,
                event:null,
                map: {
                    reported_center: {
                        lat: 1.32,
                        lng: 103.8
                    },
                    marker: {
                        position: false
                    },
                    class: "map-container",
                },
                answers:[]
            }
        },
        mounted() {
            console.log(stripe_public_key);
            inviteRepository.getByPublicUuid(
                this.id,
                {
                    include: ['event', 'answers', 'event.client', 'event.questions', 'event.updates', 'event.days', 'event.days.itinerary_items']
                }
            ).then(res => {
                this.invite = res.data;
                this.event = res.data.event;
                this.map.reported_center = {
                    lat: this.event.address_lat,
                    lng: this.event.address_lng
                }
                this.map.marker.position = {
                    lat: this.event.address_lat,
                    lng: this.event.address_lng
                }
                if(this.invite.status == 'ACCEPTED' || this.invite.status == 'REJECTED'){
                    this.status = this.invite.status;
                }
                this.loaded = true;
            });
        },

        methods: {

            confirmPaid(){
                //create payment token
                createToken().then(data => {
                    const token = data.token.id;
                    const confirm_payload = {
                        token,
                        answers:this.answers
                    };
                    return inviteRepository.confirm(this.invite.uuid, confirm_payload)
                }).then(response => {
                    console.log(response.data);
                    this.status = 'ACCEPTED';

                }).catch(error=>{
                    console.log(error);
                })
            },
            confirmUnpaid(){
                inviteRepository.confirm(this.invite.uuid, {answers:this.answers})
                    .then(response => {
                        console.log(response.data);
                        this.status = 'ACCEPTED';

                    }).catch(error=>{
                        console.log(error);
                    })
            },

            getDayString(day) {
                return moment(day.date).format("dddd Do MMMM");
            },

            answersChanged(answers) {
                // We have a list of answers. Some have changed,
                // some have been created. What do we do here?

                // answers.forEach(answer=>this.answers.push(answer));
                // console.log(answers);
                this.answers = answers;
            },

            setStatus(status) {
                this.status = status;
            },

            showBookingForm() {
                this.show_booking_form = true;
            },

            hideBookingForm() {
                this.show_booking_form = false;
            }
        },
        computed:{
            CTAText(){
                return 'Reserve your spot now'
            },

            AcceptedText(){
                return "Thanks for confirming your attendance"
            },

            RejectedText(){
                return "We're sorry you can't make it"
            },

            BookingText() {
                return "To complete your booking, please fill in the form below"
            }
        }

    }
</script>

<style scoped lang="scss">



    .confirm-block{
        background-color: #28a745;
        padding: 8rem 2rem;
        color: #ffffff;

        display: flex;
        flex-direction: column;

        align-items: center;

        &__title{
            font-size: 2rem;
            margin-bottom: 1rem;
            text-align: center;
            line-height: 1;
            margin-bottom: 2rem;
        }

        &__subtitle {
            a {
                color: white;
                font-weight: bold;
            }
        }

        &__buttons{
            display: flex;
            align-items: center;
            flex-direction: column;

            @media (min-width: 768px){
                flex-direction: row;
            }
        }

        &__yes, &__no{
            border:1px solid #ffffff;
            padding: 1rem 2rem;
            color: #ffffff;
            margin: 1rem;
            text-align: center;
            line-height: 1;
        }

        &__yes{
            font-size: 1.5rem;
        }

        &__form {
            padding: 1rem;
            border: 1px solid #28a745;
        }

        &__form-heading {
            //color: #28a745;
            font-size: 1.3rem;
            margin-top: 2rem;
        }

        &__confirm-button {
            font-size: 1.4rem;
            padding: 1rem;
            width: 100%;
            margin-top: 2rem;
        }

    }
    .updates-col{
        //@include media-breakpoint-up(md){
        //    border-left:1px solid #e6e6e6;
        //}
        border-left:1px solid #e6e6e6;
    }
    .card-payment{
        border:1px dashed #28a745;
        padding: 1rem;

        .stripe-logo{
            @media(min-width: 768px){
                float: right;
            }

        }
        .stripe-card {
            max-width: 520px;
            border: 1px solid #ced4da;
            padding: 0.5rem;
        }
        .stripe-card.complete {
            border-color: #28a745;
        }
    }
    .event-details-wrap{
        position: relative;
    }
    .event-header{
        margin-top: 3rem;
        padding: 0 15px;
    }
    .event-header__main-image{
        background-size:cover;
        min-height: 400px;
    }
    .event-header__info{
        padding-top:1rem;
        padding-bottom: 1rem;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .event-book-bar{
        border:1px solid #e6e6e6;
        position: sticky;
        top:0;
        z-index: 2;
        padding: 0 15px;
        background-color: #ffffff;
    }
    .event-book-bar__intro{
        align-items: center;

        p{
            margin: 0;
        }
    }
    .event-book-bar__right{
        border-left:1px solid #e6e6e6;
    }
    .event-book-bar__btn{
        width: 100%;
    }
    .event__description{
        padding: 1rem;
        border:1px solid #e6e6e6;
        border-top:none;
    }

    .itinerary__inner {
        padding-left: 10px;
    }


    .slide-fade-enter-active {
    transition: all .7s ease;
    }
    .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
    }

</style>